exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\na.disabled[data-v-116f448a] {\n  pointer-events: none;\n}\n.artist-list__item.overlay[data-v-116f448a]:before {\n  background: rgba(0,0,0,0.6);\n  position: absolute;\n  z-index: 99;\n  content: \"\";\n  width: 100%;\n  height: 100%;\n}\n.overlay-text[data-v-116f448a] {\n  color: #fff;\n  position: absolute;\n  z-index: 9999;\n  text-align: center;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  left: 50%;\n  width: 108px;\n}\n.artist-list[data-v-116f448a]{\n  margin-top: 2rem;\n}\n", ""]);

// exports
